import React from 'react';

const AuthSidebar = () => {

  return (


    <>
      Move to Auth header area
    </>

  );
};

AuthSidebar.propTypes = {

};

export default AuthSidebar;
